import { ImageWithTextSection } from '@quicktools/shared-components';
import IImageWithTextSection from '@quicktools/shared-components/components/landingPages/ImageWithTextSection/types';
import { useTranslation } from 'react-i18next';

function ImageSectionWhy() {
  const { t } = useTranslation();

  const imageSectionItems: IImageWithTextSection[] = [
    {
      title: t('landing.imageSection.2.title'),
      description: t('landing.imageSection.2.description'),
      imageWidth: 390,
      imgSrc: 'https://cdn140.picsart.com/64614921440768856930.png',
      imgAlt: 'color harmony meaning',
    },
    {
      title: t('landing.imageSection.3.title'),
      imageWidth: 294,
      imgSrc: 'https://cdn140.picsart.com/44446472879949314167.png',
      imgAlt: 'primary, secondary & tertiary colors',
      imageRight: true,
      children: (
        <>
          <div style={{ marginBottom: '32px' }}>
            {t('landing.imageSection.3.children.paragraph')}
          </div>
          <div>
            {t('landing.imageSection.3.children.list.0')} <br />
            {t('landing.imageSection.3.children.list.1')} <br />
            {t('landing.imageSection.3.children.list.2')} <br />
            {t('landing.imageSection.3.children.list.3')}
          </div>
        </>
      ),
    },
    {
      title: t('landing.imageSection.3.title'),
      description: t('landing.imageSection.3.description'),
      imageWidth: 444,
      imgSrc: 'https://cdn140.picsart.com/72079102992594164757.png',
      imgAlt: 'color temperature meaning',
    },
  ];

  return (
    <>
      {imageSectionItems.map((props, index) => (
        <ImageWithTextSection {...props} key={index} />
      ))}
    </>
  );
}

export default ImageSectionWhy;
